import { jsx as t } from "react/jsx-runtime";
import n from "react";
import { FilePreview as i } from "../file-preview/index.mjs";
import { twMerge as o } from "tailwind-merge";
import "../../enums/file-type-enum.mjs";
import { FileTypeEnum as m } from "@systemeio/types";
const a = n.memo(({ file: e, className: r }) => e.type.startsWith("image/") ? /* @__PURE__ */ t(
  i,
  {
    src: URL.createObjectURL(e),
    fileType: m.Image,
    alt: e.name,
    className: r,
    isThumbnail: !0,
    title: e.name
  }
) : e.type === "application/pdf" ? /* @__PURE__ */ t(
  "div",
  {
    className: o(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      r
    ),
    title: e.name,
    children: /* @__PURE__ */ t(
      "embed",
      {
        src: URL.createObjectURL(e),
        type: e.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : e.type.startsWith("video/") ? /* @__PURE__ */ t(
  i,
  {
    src: URL.createObjectURL(e),
    fileType: m.Video,
    alt: e.name,
    className: r,
    isThumbnail: !0,
    title: e.name
  }
) : /* @__PURE__ */ t(
  i,
  {
    src: "",
    fileType: m.Document,
    className: r,
    isThumbnail: !0,
    title: e.name
  }
));
a.displayName = "FilePreviewFromOS";
export {
  a as FilePreviewFromOS
};
